export default __webpack_public_path__ + "static/media/man-2.cf3d1eef.png";